<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">Forms</div>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <!--Forms-->
                <div class="forms-container">
                    <div class="row no-margin">
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Customer :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="locationId"
                                          name="locationId"
                                          id="locationId"
                                          label="text"
                                          :filterable="false"
                                          :options="locationArr"
                                          :clearable=false
                                          placeholder="Select Location">
                                    <template slot="no-options">
                                        Search Location...
                                    </template>
                                    <template slot="option" slot-scope="option">
                                        <div class="d-center">
                                            {{ option.text }}
                                        </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center">
                                            {{ option.text }}
                                        </div>
                                    </template>
                                </v-select>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Contact :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="locationId"
                                          name="locationId"
                                          id="locationId"
                                          label="text"
                                          :filterable="false"
                                          :options="locationArr"
                                          placeholder="Select Location">
                                    <template slot="no-options">
                                        Search Location...
                                    </template>
                                    <template slot="option" slot-scope="option">
                                        <div class="d-center">
                                            {{ option.text }}
                                        </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center">
                                            {{ option.text }}
                                        </div>
                                    </template>
                                </v-select>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Collector :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="locationId"
                                          name="locationId"
                                          id="locationId"
                                          label="text"
                                          :filterable="false"
                                          :options="locationArr"
                                          placeholder="Select Location">
                                    <template slot="no-options">
                                        Search Location...
                                    </template>
                                    <template slot="option" slot-scope="option">
                                        <div class="d-center">
                                            {{ option.text }}
                                        </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center">
                                            {{ option.text }}
                                        </div>
                                    </template>
                                </v-select>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Priority :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <b-form-radio-group v-model="selected"
                                                    :options="options"
                                                    name="radioInline">
                                </b-form-radio-group>
                            </div>
                        </div>
                        <div class="col-12 forms-block">
                            <a href="https://github.com/ankurk91/vue-flatpickr-component/blob/master/examples/App.vue">Vue FlatPickr Github Demo</a>
                        </div>
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Select Date :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <flat-pickr 
                                    v-model="date"
                                    class="form-control" 
                                    placeholder="Select date"               
                                    name="date"
                                >
                                </flat-pickr>
                            </div>
                        </div>
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Date Time :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <flat-pickr 
                                    v-model="date1"
                                    :config="config"
                                    @on-change="doSomethingOnChange" 
                                    @on-close="doSomethingOnClose"
                                    class="form-control" 
                                    placeholder="Select date"               
                                    name="date1"
                                >
                                </flat-pickr>
                            </div>
                        </div>
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Start Date : </div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <flat-pickr 
                                    class="form-control"
                                    :config="configStart"
                                    v-model="startDate"
                                    @on-change="onStartChange"
                                    placeholder="Select Start Date"
                                    >
                                </flat-pickr>
                            </div>
                        </div>
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">End Date:</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <flat-pickr 
                                    class="form-control"
                                    :config="configEnd"
                                    v-model="endDate"
                                    @on-change="onEndChange"
                                    placeholder="Select End Date"            
                                >
                                </flat-pickr>
                            </div>
                        </div>
                         <div class="col-12 forms-block">
                            <a href="https://github.com/ankurk91/vue-bootstrap-datetimepicker/blob/master/examples/App.vue">Vue Bootstrap 4 DatetimePicker Github Demo</a>
                        </div>
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Select Date :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <date-picker 
                                    placeholder="Select Date"
                                    class="form-control"
                                    v-model="bootstrapDate" 
                                    :config="bootstrapOptions"
                                >
                                </date-picker>
                            </div>
                        </div>
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Date Time :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <date-picker
                                    v-model="bootstrapDate1"
                                    :config="bootstrapOptionsTime"
                                    class="form-control" 
                                    placeholder="Select Date Time"               
                                    name="bootstrapdate1"
                                >
                                </date-picker>
                            </div>
                        </div>
                        <!--<div class="col-3 forms-block">
                            <a href="https://github.com/mariomka/vue-datetime">vue-datetime</a>
                        </div>-->
                        <div class="col-12 forms-block">
                            <div class="col-3 form-title paddingleft0">
                                <div class="form-label">Upload Document :</div>
                            </div>
                            <div class="col-9 form-input-control paddingleft0">
                                <vue-dropzone
                                    ref="dropzone" 
                                    id="dropzone" 
                                    :options="dropzoneOptions"
                                    @vdropzone-success = "uploadAttachment"
                                    @vdropzone-removed-file="removedSelectedFile"
                                    :useCustomSlot=true
                                    >
                                    <div class="dropzone-custom-content">
                                        <h4 class="dropzone-custom-title">Drop files here or click to upload.</h4>
                                        <div class="subtitle">(Select files from your computer.)</div>
                                    </div>
                                </vue-dropzone>
                                <!-- <div class="requiredstar">*</div> -->
                            </div>
                        </div>
                        <div class="col-12 forms-block">
                            <div class="col-3 form-title paddingleft0">
                                <div class="form-label">Description :</div>
                            </div>
                            <div class="col-9 form-input-control paddingleft0">
                                <tinymce :plugins="['advlist autolink lists link image charmap print preview hr anchor pagebreak', 'searchreplace wordcount visualblocks visualchars code fullscreen', 'insertdatetime media nonbreaking save table contextmenu directionality','template paste textcolor colorpicker textpattern imagetools toc help emoticons hr codesample']" id="description" v-model="description" class= "" ref="tm" :other_options="options"></tinymce>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Forms -->
            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import vSelect from 'vue-select';
    import { Form } from 'bootstrap-vue/es/components';
    import { FormRadio } from 'bootstrap-vue/es/components';
    import BackendFooter from '@/components/backend/partials/footer';

    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';

    /* Vue FlatPickr */
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    /* Bootstrap Data-Picker */
    //import 'bootstrap/dist/css/bootstrap.css';
    import datePicker from 'vue-bootstrap-datetimepicker';
    import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
    
    import tinymce from 'vue-tinymce-editor';
    export default {
        name: 'Center',
        components: {
            'v-select': vSelect,
            'app-backend-footer': BackendFooter,
            'vueDropzone': vue2Dropzone,
            'tinymce': tinymce,
            flatPickr,
            datePicker,
        },
        data() {
            return {
                description:'',
                options: {
                    /*language_url: 'http://example.com/js/langs/fa_IR.js' //This url points to location of persian language file.*/
                },
                bootstrapDate: new Date(),
                bootstrapDate1: new Date(),
                date: null,
                date1: null,
                startDate: null,
                endDate: null,
                // Get more form https://chmln.github.io/flatpickr/options/
                config: {
                    wrap: true, // set wrap to true only when using 'input-group'
                    altFormat: 'm/d/Y G:i K',
                    altInput: true,
                    dateFormat: 'Y-m-d H:i:S',
                    enableTime: true,
                    //locale: Hindi, // locale for this instance only          
                },
                configStart: {
                    wrap: true, // set wrap to true only when using 'input-group'
                    altFormat: 'm/d/Y G:i K',
                    altInput: true,
                    dateFormat: 'Y-m-d H:i:S',
                    enableTime: true,
                    //minDate: new Date(),
                    maxDate: null
                    //locale: Hindi, // locale for this instance only          
                },
                configEnd: {
                    wrap: true, // set wrap to true only when using 'input-group'
                    altFormat: 'm/d/Y G:i K',
                    altInput: true,
                    dateFormat: 'Y-m-d H:i:S',
                    enableTime: true,
                    minDate: null
                    //locale: Hindi, // locale for this instance only          
                },
                bootstrapOptions: {
                    format: 'MM/DD/YYYY',
                    useCurrent: false,
                },
                bootstrapOptionsTime: {
                    /*format: 'MM/DD/YYYY',
                    useCurrent: false,*/
                    format: 'MM/DD/YYYY hh:mm:ss A',
                    useCurrent: false,
                    showClear: true,
                    showClose: true,
                    allowInputToggle: true,
                },
                dropzoneOptions: {
                    /*url: process.env.ROOT_API + "/store_document",*/
                    url: "https://httpbin.org/post",
                    method: "POST",
                    autoProcessQueue: true,
                    maxFilesize: 250, //MB
                    dictFileTooBig: "File is to big ({{filesize}}MB). Max allowed file size is {{maxFilesize}}MB",
                    maxFiles: 1,
                    thumbnailWidth: 150, //px
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    dictCancelUpload: 'Cancel',
                    //acceptedFiles: ".jpg, .jpeg, .png",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("tkn"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    }
                },
                attachmentPaths: '',
                attachmentType: '',
                attachmentSize: '',
                locationId: {value: '1', text: 'Arizona'},
                locationArr: [
                    {value: '0', text: 'All'},
                    {value: '1', text: 'Arizona'},
                    {value: '2', text: 'California'},
                    {value: '3', text: 'Nevada'},
                    {value: '4', text: 'Other'},
                ],

                selected: 'first',
                options: [
                    {text: 'First radio', value: 'first'},
                    {text: 'Second radio', value: 'second'},
                    {text: 'Third radio', value: 'third'}
                ]
            }



        },
        beforeMount: function () {

        },
        mounted: function () {

        },
        methods: {
            doSomethingOnChange(selectedDates, dateStr, instance) {
                var self = this;
                console.log("Date Change Called : " + self.date1);
            },
            doSomethingOnClose() {
                var self = this;
                console.log("Picker Close Called : " + self.date1);
            },
            onStartChange(selectedDates, dateStr, instance) {
                var self = this;
                self.$set(self.configEnd, 'minDate', dateStr);
            },
            onEndChange(selectedDates, dateStr, instance) {
                var self = this;
                self.$set(self.configStart, 'maxDate', dateStr);
            },
            uploadAttachment(file, response) {
                var self = this;
                //console.log(file);

                self.attachmentPaths = response.content;
                self.attachmentType = file.type;
                self.attachmentSize = file.size;
            },
            removedSelectedFile(file, xhr, error) {

                var self = this;
                var removeFile = self.attachmentPaths;
                self.removeFileFromServer(removeFile);
            },
            removeFileFromServer: function (filePath) {

                var self = this;
                self.attachmentPaths = "";
                self.attachmentType = "";
                self.attachmentSize = "";
                self.removeAllFiles();
            },
            removeAllFiles() {
                var self = this;
                self.$refs.dropzone.removeAllFiles();
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/forms.vue